import { tutorialAllowedPaths } from '@wwt/shared/config'

import { TutorialStatus } from '../types/TutorialStatus.ts'

export const isTutorialAllowed = (
	pathname: string,
	tutorialStatus: TutorialStatus | null
): boolean => {
	const isPathAllowed = tutorialAllowedPaths.includes(pathname)

	return (
		(!tutorialStatus || tutorialStatus === TutorialStatus.RESET) &&
		isPathAllowed
	)
}
